import template from './sw-cms-preview-text-teaser.html.twig';
import './sw-cms-preview-text-teaser.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
